import { RevenueGroupItem, SegmentOption, GameSegmentType, TimeBasicType, RevenueSegmentType, FigureData } from '../types'
import { reduce } from 'lodash-es';

export const BenchmarkSegment: SegmentOption<GameSegmentType>[] = [
  {
    text: 'dbi_benchmark_shooter',
    value: 'shooter',
    name: 'Shooter',
  },
  {
    text: 'dbi_benchmark_soc',
    value: 'soc',
    name: 'SOC',
  },
  {
    text: 'dbi_benchmark_rpg',
    value: 'rpg',
    name: 'RPG',
  },
  {
    text: 'dbi_benchmark_mmp',
    value: 'mmo',
    name: 'MMO',
  },
  {
    text: 'dbi_benchmark_casual',
    value: 'casual',
    name: 'Casual',
  },
  {
    text: 'dbi_benchmark_customized',
    value: 'customize',
    name: 'Customized',
  },
];

export const BenchmarkSecondSegment: SegmentOption<RevenueSegmentType>[] = [
  {
    text: 'dbi_benchmark_us_digital',
    value: 'us_digital_revenue',
  },
  {
    text: 'dbi_benchmark_price_steam_data',
    value: 'business',
  },
  {
    text: 'dbi_benchmark_player_engagement',
    value: 'player_activity',
  },
  {
    text: 'dbi_benchmark_social_channels',
    value: 'socail_channels',
  },
  {
    text: 'dbi_benchmark_basic_info',
    value: 'basic_info',
  },
];


export const RevenueUnitsSegment: SegmentOption<string>[] = [
  {
    text: 'dbi_revenue',
    value: 'revenue',
  },
  {
    text: 'dbi_metric_units',
    value: 'unit',
  },
];


export const DefaultRevenueValue = {
  platform: ['pc', 'console'],
  start_date: ['earliest_data'],
  time_interval: [
    'year_separate(y1-y5)',
    'total',
    'earliest_date_release_date',
  ],
  monetization: ['all'],
  metric_type: ['rev'],
};


export const RevenueGroupList: RevenueGroupItem[] = [
  {
    name: 'dbi_benchmark_platform',
    value: 'platform',
    option: [
      {
        label: 'dbi_pc',
        value: 'pc',
      },
      {
        label: 'dbi_console',
        value: 'console',
      },
      {
        label: 'dbi_benchmark_pc_console',
        value: 'pc+console',
      },
    ],
  },
  {
    name: 'dbi_benchmark_start_date',
    value: 'start_date',
    option: [
      {
        label: 'dbi_benchmark_earliest_data_date',
        value: 'earliest_data',
        res: 'est',
      },
      {
        label: 'dbi_benchmark_release_date',
        value: 'release_date',
        res: 'fl',
      },
    ],
  },
  {
    name: 'Time interval',
    value: 'time_interval',
    option: [
      {
        label: 'Year accumulated (Y1-Y5)',
        value: 'year_accumulated(y1-y5)', // 转 ['1y', '2y', '3y', '4y', '5y']
        res: ['1y', '2y', '3y', '4y', '5y'],
      },
      {
        label: 'Year separate (Y1-Y5)',
        value: 'year_separate(y1-y5)', // 转 ['s1y', 's2y', 's3y', 's4y', 's5y']
        res: ['s1y', 's2y', 's3y', 's4y', 's5y'],
      },
      {
        label: 'dbi_benchmark_total',
        value: 'total',
        res: 'af',
      },
      {
        label: 'dbi_benchmark_earliest_release',
        value: 'earliest_date_release_date',
        res: 'bf',
      },
    ],
  },
  {
    name: 'dbi_benchmark_monetization',
    value: 'monetization',
    option: [
      {
        label: 'dbi_benchmark_all_sum',
        value: 'all',
      },
      {
        label: 'dbi_benchmark_premium',
        value: 'flg',
      },
      {
        label: 'dbi_benchmark_mtx_subscription',
        value: 'mtx',
      },
      {
        label: 'dbi_benchmark_dlc_pass',
        value: 'dlc',
      },
    ],
  },
  {
    name: 'dbi_benchmark_metric_type',
    value: 'metric_type',
    option: [
      {
        label: 'dbi_revenue',
        value: 'rev',
      },
      {
        label: 'dbi_metric_units',
        value: 'unit',
      },
    ],
  },
];


export const defaultFigureData: FigureData = {
  countryPieData: [],
  gasLinexAxis: [],
  gasLineData: [],
  summary: {},
  trends: {
    revenue: [],
    unit: [],
  },
  usRevenue: [],
  retentionCurve: [],
  arpuRetention: [],
}


export const defaultConfigValue = {
  soc: [],
  shooter: [],
  rpg: [],
  mmo: [],
  casual: [],
  customize: [],
  all: [],
};


export const timeActionConfig: { [key in TimeBasicType]: any } = {
  'Earliest Date': {
    pc: {
      start: '10%',
      end: '45%',
      process: '10%',
      radio: '48%',
    },
    console: {
      start: '20%',
      end: '50%',
      process: '10%',
      radio: '48%',
    },
  },
  'Release Date': {
    pc: {
      start: '10%',
      end: '45%',
      process: '45%',
      radio: '30%',
    },
    console: {
      start: '20%',
      end: '50%',
      process: '45%',
      radio: '30%',
    },
  },
  'PC&Console Aligned by Earliest Date': {
    pc: {
      start: '10%',
      end: '45%',
      process: '10%',
      radio: '48%',
    },
    console: {
      start: '20%',
      end: '50%',
      process: '15%',
      radio: '48%',
    },
  },
  'PC&Console Aligned by Release Date': {
    pc: {
      start: '10%',
      end: '45%',
      process: '45%',
      radio: '30%',
    },
    console: {
      start: '20%',
      end: '50%',
      process: '50%',
      radio: '30%',
    },
  },
};

export const GameKConfig: { [key in GameSegmentType]?: any } = {
  shooter: {
    x: [1.7, 2.2, 2.8, 3.9], // x轴分割点
    y: [1.5, 2, 3, 5], // Y轴分割点
    k: [3, 7, 11, 15], // 反比例函数控制,
    xTitle: ['5%', '8%', '10%', '12%'],
    yTitle: ['$1.5', '$2.0', '$3.0', '$5.0'],
    retention: {
      S: 'D30: > 12%',
      A: 'D30: 10% ~ 12%',
      B: 'D30: 8% ~ 10%',
      C: 'D30: 5% ~ 8%',
      D: 'D30: < 5%',
    },
    arpmau: {
      S: '> $5.0',
      A: '$3.0 ~ $5.0',
      B: '$2.0 ~ $3.0',
      C: '$1.5 ~ $2.0',
      D: '< $1.5',
    },
  },
  soc: {
    x: [1.7, 2.2, 2.8, 3.9], // x轴分割点
    y: [1.5, 2, 3, 5],
    k: [3, 7, 11, 15],
    xTitle: ['5%', '8%', '10%', '12%'],
    yTitle: ['$1.5', '$2.0', '$3.0', '$5.0'],
    retention: {
      S: 'D30: > 12%',
      A: 'D30: 10% ~ 12%',
      B: 'D30: 8% ~ 10%',
      C: 'D30: 5% ~ 8%',
      D: 'D30: < 5%',
    },
    arpmau: {
      S: '> $5.0',
      A: '$3.0 ~ $5.0',
      B: '$2.0 ~ $3.0',
      C: '$1.5 ~ $2.0',
      D: '< $1.5',
    },
  },
  rpg: {
    x: [1.7, 2.2, 2.8, 3.9], // x轴分割点
    y: [1.2, 1.8, 2.4, 3.0],
    k: [3.0, 5.5, 8.0, 10.5],
    xTitle: ['5%', '8%', '10%', '12%'],
    yTitle: ['$1.2', '$1.8', '$2.4', '$3.0'],
    retention: {
      S: 'D30: > 12%',
      A: 'D30: 10% ~ 12%',
      B: 'D30: 8% ~ 10%',
      C: 'D30: 5% ~ 8%',
      D: 'D30: < 5%',
    },
    arpmau: {
      S: '> $3.0',
      A: '$2.4 ~ $3.0',
      B: '$1.8 ~ $2.4',
      C: '$1.2 ~ $1.8',
      D: '< $1.2',
    },
  },
  mmo: {
    x: [1.7, 2.2, 2.8, 3.9], // x轴分割点
    y: [2, 3, 5, 8],
    k: [5, 8, 12, 18],
    xTitle: ['5%', '8%', '10%', '12%'],
    yTitle: ['$2.0', '$3.0', '$5.0', '$8.0'],
    retention: {
      S: 'D30: > 12%',
      A: 'D30: 10% ~ 12%',
      B: 'D30: 8% ~ 10%',
      C: 'D30: 5% ~ 8%',
      D: 'D30: < 5%',
    },
    arpmau: {
      S: '> $8',
      A: '$5.0 ~ $8.0',
      B: '$3.0 ~ $5.0',
      C: '$2.0 ~ $3.0',
      D: '< $2.0',
    },
  },
  casual: {
    x: [1.7, 2.2, 2.8, 3.9], // x轴分割点
    y: [0.5, 1, 1.5, 2],
    k: [0.5, 2, 3.5, 5],
    xTitle: ['5%', '8%', '10%', '12%'],
    yTitle: ['$0.5', '$1.0', '$1.5', '$2.0'],
    retention: {
      S: 'D30: > 12%',
      A: 'D30: 10% ~ 12%',
      B: 'D30: 8% ~ 10%',
      C: 'D30: 5% ~ 8%',
      D: 'D30: < 5%',
    },
    arpmau: {
      S: '> $2.0',
      A: '$1.5 ~ $2.0',
      B: '$1.0 ~ $1.5',
      C: '$0.5 ~ $1.0',
      D: '< $0.5',
    },
  },
  customize: {
    x: [1.7, 2.2, 2.8, 3.9], // x轴分割点
    y: [1.039, 1.193, 1.868, 3.706],
    k: [2.43, 4.63, 6.83, 9.03],
    xTitle: ['5%', '8%', '10%', '12%'],
    yTitle: ['$1.0', '$1.2', '$1.9', '$3.7'],
    retention: {
      S: 'D30: > 12%',
      A: 'D30: 10% ~ 12%',
      B: 'D30: 8% ~ 10%',
      C: 'D30: 5% ~ 8%',
      D: 'D30: < 5%',
    },
    arpmau: {
      S: '> $3.7',
      A: '$1.9 ~ $3.7',
      B: '$1.2 ~ $1.9',
      C: '$1.0 ~ $1.2',
      D: '< $1.0',
    },
  },
};


export const RevenueSort: any = {
  pc: 1,
  console: 2,
  'pc+console': 3,
  est: 1,
  fl: 2,
  all: 1,
  flg: 2,
  mtx: 3,
  dlc: 4,
  unit: 1,
  rev: 2,
};


export const filedNameConfig = reduce(
  RevenueGroupList,
  (result, item) => {
    item.option.forEach((config) => {
      if (
        ['year_accumulated(y1-y5)', 'year_separate(y1-y5)'].includes(
          config.value,
        )
      ) {
        if (Array.isArray(config?.res)) {
          config?.res.forEach((year, index) => {
            result[year] =
              config.value === 'year_accumulated(y1-y5)'
                ? `Year_accumulated(Y${index + 1})`
                : `Y${index + 1}`;
          });
        }
      } else {
        const filed = config?.res || config.value;
        result[filed as string] = config.label;
      }
    });
    return result;
  },

  {} as { [key: string]: string },
);
